import type { PrhHolidayHomeDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/prh';
import type { TableInformation } from '../../../../config/flavourConfig';
import { getCurrencyString } from '../../../../utils/currencyUtil';
import {
    formatAmountWithCurrency,
    getCoverageTermValue,
    isCoverageSelected
} from '../coverableDetailsInsuranceSumsConfig';

const getPrhHHInsuranceSumsCoverableDetailsConfig = (
    holidayHomeCoverable: PrhHolidayHomeDTO,
    getHippoText: (resourceKey: string) => string
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: getHippoText('DSS- INSURANCE-SUMS-FIRST-RISK'),
                fieldValue:
                    holidayHomeCoverable.firstRiskSum !== undefined
                        ? getCurrencyString(holidayHomeCoverable.firstRiskSum, ' kr.')
                        : undefined,
                hidden: holidayHomeCoverable.firstRiskSum === undefined
            },
            {
                name: getHippoText('DSS- INSURANCE-SUMS-HH-CONTENT'),
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        holidayHomeCoverable,
                        'PRHPrivateContentCov',
                        'PRHPrivateContentCovSumInsuredNew'
                    )
                ),
                hidden: !isCoverageSelected(holidayHomeCoverable, 'PRHPrivateContentCov')
            }
        ]
    };
};

export { getPrhHHInsuranceSumsCoverableDetailsConfig };
